import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { TalaveraVine } from "./TalaveraVine";
import { TalaveraStrip } from "./TalaveraStrip";

const MaskLine = ({ children, delay, className = "" }) => {
  const [done, setDone] = useState(false);
  return (
    <div className={`px-12 -mx-12 py-12 -my-12 ${done ? "" : "overflow-hidden"}`}>
      <motion.div
        className={className}
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1.15, delay, ease: [0.22, 1, 0.36, 1] }}
        onAnimationComplete={() => setDone(true)}
      >
        {children}
      </motion.div>
    </div>
  );
};

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const leafTopY = useTransform(scrollYProgress, [0, 1], [0, -160]);
  const leafBottomY = useTransform(scrollYProgress, [0, 1], [0, 200]);
  const contentY = useTransform(scrollYProgress, [0, 1], [0, 120]);
  const fade = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section ref={ref} data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-cream">
      <div className="absolute left-1 sm:left-10 top-1/2 -translate-y-1/2 pointer-events-none select-none">
        <motion.div style={{ y: leafTopY }} className="w-[44px] sm:w-[72px]">
          <TalaveraVine className="w-full h-full" />
        </motion.div>
      </div>
      <div className="absolute right-1 sm:right-10 top-1/2 -translate-y-1/2 pointer-events-none select-none">
        <motion.div style={{ y: leafBottomY }} className="w-[44px] sm:w-[72px] -scale-x-100">
          <TalaveraVine className="w-full h-full" />
        </motion.div>
      </div>
      <motion.div style={{ y: contentY, opacity: fade }} className="relative z-10 w-full text-center px-6 pt-16">
        <MaskLine delay={0.1}>
          <p className="font-script text-clay text-3xl md:text-4xl">Nos casamos</p>
        </MaskLine>
        <MaskLine delay={0.3}>
          <h1 className="font-script text-clay leading-[0.95] text-[clamp(5rem,17vw,11.5rem)]">Emma</h1>
        </MaskLine>
        <MaskLine delay={0.45}>
          <span className="font-serif italic text-sage text-4xl md:text-6xl">&</span>
        </MaskLine>
        <MaskLine delay={0.6}>
          <h1 className="font-script text-clay leading-[0.95] text-[clamp(5rem,17vw,11.5rem)]">Jhonny</h1>
        </MaskLine>
        <MaskLine delay={0.85}>
          <p className="mt-10 font-serif tracking-[0.4em] uppercase text-xs md:text-sm text-stone">
            Sábado · 10 · Octubre · 2026
          </p>
        </MaskLine>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1, duration: 0.8 }} className="mt-8">
          <TalaveraStrip count={3} />
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.35, duration: 0.8 }}>
          <a
            data-testid="hero-rsvp-button"
            href="#rsvp"
            className="inline-block mt-12 rounded-full border border-clay text-clay px-10 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-clay hover:text-cream transition-colors"
          >
            Confirmar asistencia
          </a>
        </motion.div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.8 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-clay/60"
      >
        <ChevronDown className="animate-bounce" size={22} strokeWidth={1.5} />
      </motion.div>
    </section>
  );
};
